@if (settings) {
  <mat-card>
    <mat-form-field class="example-full-width">
      <mat-label>Näytettävien lunastuksien kpl määrä</mat-label>
      <input type="number" [(ngModel)]="settings.redemptionQueSize" (change)="change()" matInput>
    </mat-form-field>
  </mat-card>
}
